<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>化身灶门炭治郎，进入《英雄攻战》的时间轮回，重构记忆，觉醒宿命，解锁全新隐藏招式，锻造讨鬼信物，组建强阵鬼杀小队，斩断命运锁，终结恶鬼改写鬼灭因果！</p>
    <!-- <pre> -->
    <h2 class="title" style="margin-bottom: 0px">游戏特色</h2>
    <div class="content">
      <div class="content-item">
        <h4>【鬼月讨伐 全番重启】</h4>
        试炼岩石、鼓之屋、无限列车、蜘蛛山、追击半天狗、花街探查、守卫锻刀村，名番延伸再创，剧情连载演绎，结局走向由你组建的鬼杀小队共同改写！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【动画颜值 柱弦重组】</h4>
        特色皮肤系统再现角色背景故事，登录领千抽直送SSR，轻松集齐全卡池，无损转换，重生回退不限，轻烧脑微手操策略改变阵容应对每个鬼杀场景！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【爆燃爽斗 热血鬼杀】</h4>
        还原全角色核心招式技能，全屏动画特效提升打击爽感，CV配音加持战斗BGM，革新全视觉真沉浸热血爽战，每场讨鬼冒险打斗都媲美剧场版！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【轻松日常 惊喜豪礼】</h4>
        鬼灭派对街，庭院厨房超温馨，副本还带隐藏彩蛋，活动多样超有趣，新服频开，跨服联合玩法常在，社交世界讨论多，福利拉满大放送，零氪制霸鬼域！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
